import { FloatingInstructions } from './FloatingInstructions';
export default FloatingInstructions;
